<template>

<div>

	<com-title text="Subscriptions" />

	<com-item route="Membership.Members.Subscriptions" text="Active" :count="$membership.count.subscriptions.active" />
	<com-item route="Membership.Members.Expiring" text="Expiring" :count="$membership.count.subscriptions.expiring" />
	<com-item route="Membership.Members.Cancelled" text="Cancelled" :count="$membership.count.subscriptions.cancelled" />

	<com-title text="Setup" />

	<com-item route="Membership.Members.Captures" text="Capture" />
	<com-item route="Membership.Members.Tags" text="Tags" />
	<com-item route="Membership.Members.Types" text="Types" />

</div>

</template>

<script>

export default {

	components: {
		'com-title': () => import('./../../panel/common/Title'),
		'com-item': () => import('./../../panel/common/Item')
	}

}

</script>

<style scoped>

</style>
